export default __webpack_public_path__ + "static/media/jpeg_icon.3c7bd507.png";